import { useNavigate } from "react-router-dom";
import { CONSENT_KEY } from "@/utils/consent";
import AppLayout from "@/layouts/AppLayout";
import { useEffect, useState } from "react";
import { getConsent, setConsent } from "@/utils/consent";
import { useLocation, } from "react-router-dom";

type ConsentStatus = "accepted" | "declined" | null;

export default function ConsentPage() {
    const navigate = useNavigate();
    const [consentStatus, setConsentStatus] = useState<ConsentStatus>(null);

    const location = useLocation();
    const navState = location.state as { reason?: string } | null;

    const [flashDecline, setFlashDecline] = useState(false);

    useEffect(() => {
        const saved = getConsent();

        if (saved === "accepted" || saved === "declined") {
            setConsentStatus(saved);
        } else {
            setConsentStatus(null);
        }
    }, []);

    useEffect(() => {
        const shouldFlash =
            navState?.reason === "declined";

        if (shouldFlash) {
            setFlashDecline(true);
            const timer = window.setTimeout(() => setFlashDecline(false), 3000);
            return () => window.clearTimeout(timer);
        }
    }, [navState]);

    useEffect(() => {
        const saved = localStorage.getItem(CONSENT_KEY);
        if (saved === "accepted" || saved === "declined") {
            setConsentStatus(saved);
        } else {
            setConsentStatus(null);
        }
    }, []);
    
    const handleAccept = () => {
        setConsent(true);
        setConsentStatus("accepted");
        navigate("/",);
    };

    const handleDecline = () => {
        setConsent(false);
        setConsentStatus("declined");
        navigate("/",);
    };

    return (
        <AppLayout
            title="Όροι χρήσης"
            sidebarOpen={false}
            onToggleSidebar={() => {}}
        >
            <div className="min-h-screen bg-gray-50 px-6 py-10 mx-auto w-full">
                <div className="max-w-4xl mx-auto">
                    
                    <p className="text-xs uppercase tracking-wider text-gray-400 mb-2">
                        EU GDPR · Όροι Χρήσης
                    </p>

                    <h1 className="text-2xl font-medium text-gray-900 mb-6">
                        Όροι Χρήσης
                    </h1>

                    <div className="text-gray-600 leading-7 space-y-4 text-justify">
                        <p>
                            Το FairLegal αποτελεί μια καινοτόμο ερευνητική πρωτοβουλία που στοχεύει στην ανάπτυξη ενός Μεγάλου Γλωσσικού Μοντέλου (LLM) Τεχνητής Νοημοσύνης,
                            ικανού να εντοπίζει και να περιορίζει τη μεροληψία λόγω φύλου σε νομικά και διοικητικά κείμενα, συμβάλλοντας στην ενίσχυση της διαφάνειας και της
                            ισότητας σε κρίσιμους τομείς όπως η νομολογία, οι διαδικασίες πρόσληψης και οι δημόσιες προκηρύξεις. Η εφαρμογή εντάσσεται στο πλαίσιο των ευρωπαϊκών
                            κατευθύνσεων για «Αξιόπιστη Τεχνητή Νοημοσύνη», ευθυγραμμιζόμενη με τις αρχές του Κανονισμού (ΕΕ) για την Προστασία Δεδομένων (GDPR) και του υπό
                            διαμόρφωση Κανονιστικού Πλαισίου για την ΤΝ (AI Act).
                        </p>

                        <p>
                            Η χρήση της εφαρμογής προϋποθέτει την αποδοχή των παρόντων όρων. Ο χρήστης υποχρεούται να χρησιμοποιεί το εργαλείο με τρόπο νόμιμο, ηθικό και σύμφωνο
                            με τον σκοπό του, αποφεύγοντας την εισαγωγή δεδομένων που περιλαμβάνουν προσωπικές πληροφορίες τρίτων, ευαίσθητα δεδομένα ή περιεχόμενο που υπόκειται
                            σε περιορισμούς πνευματικής ιδιοκτησίας χωρίς σχετική άδεια. Ο χρήστης διατηρεί την ευθύνη για το περιεχόμενο που εισάγει στο σύστημα και αναγνωρίζει
                            ότι η χρήση του εργαλείου δεν υποκαθιστά νομική συμβουλή ή επίσημη διοικητική κρίση.
                        </p>

                        <p>
                            Το FairLegal έχει σχεδιαστεί με γνώμονα την αρχή της ελαχιστοποίησης δεδομένων. Δεν πραγματοποιείται αποθήκευση, καταγραφή ή διαβίβαση των δεδομένων που
                            εισάγονται από τον χρήστη σε εξωτερικούς διακομιστές. Όλη η επεξεργασία πραγματοποιείται τοπικά στο περιβάλλον του φυλλομετρητή (browser) του χρήστη,
                            διασφαλίζοντας αυξημένο επίπεδο ιδιωτικότητας και ασφάλειας.
                        </p>

                        <p>
                            Επιπλέον, το σύστημα δύναται να αξιοποιεί ανωνυμοποιημένα ή μη ταυτοποιήσιμα δεδομένα αποκλειστικά για ερευνητικούς και βελτιωτικούς σκοπούς, στο πλαίσιο της
                            ανάπτυξης αξιόπιστων και ηθικά σχεδιασμένων συστημάτων Τεχνητής Νοημοσύνης. Με την αποδοχή των όρων, ο χρήστης συναινεί στη χρήση των δεδομένων του για τους
                            ανωτέρω σκοπούς, υπό την προϋπόθεση ότι δεν παραβιάζονται δικαιώματα ιδιωτικότητας ή πνευματικής ιδιοκτησίας.
                        </p>
                        
                        <p>
                            Η ομάδα ανάπτυξης του FairLegal καταβάλλει κάθε δυνατή προσπάθεια για την ακρίβεια και αξιοπιστία των αποτελεσμάτων, ωστόσο δεν φέρει ευθύνη για τυχόν σφάλματα,
                            παραλείψεις ή ερμηνείες που προκύπτουν από τη χρήση του εργαλείου.
                        </p>
                    </div>

                    {/* Actions */}
                    {flashDecline && (
                        <div className="mb-6 animate-pulse rounded-2xl border border-red-300 bg-red-50 px-4 py-3 text-sm font-medium text-red-800 shadow-sm">
                            Έχει καταγραφεί μη αποδοχή των όρων. Για να συνεχίσετε, πρέπει να αποδεχθείτε τους όρους χρήσης.
                        </div>
                    )}
                    <div className="mt-10 flex gap-3">
                        <button
                            onClick={handleDecline}
                            className={`px-4 py-2 rounded-lg border transition-all duration-150 ${
                                flashDecline || consentStatus === "declined"
                                    ? "border-red-500 text-red-700 bg-red-100 shadow-md animate-pulse"
                                    : "border-gray-300 text-gray-600 hover:border-gray-400 hover:bg-gray-100"
                            }`}
                            >
                            Δεν αποδέχομαι
                        </button>

                        <button
                            onClick={handleAccept}
                            className={`px-4 py-2 rounded-lg border transition-all duration-150
                                ${
                                consentStatus === "accepted"
                                    ? "border-green-500 text-green-600 bg-green-50 hover:border-green-600 hover:text-green-700 hover:bg-green-100"
                                    : "border-gray-500 text-gray-600 hover:border-gray-700 hover:bg-gray-300"
                                }
                            `}
                        >
                            Αποδέχομαι
                        </button>
                    </div>

                </div>
            </div>
        </AppLayout>
    );
}